import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchCoachings = createAsyncThunk('coachings/fetch', async (params = {}) => {
  const { data } = await api.get('/coachings/', { params });
  return data;
});

export const fetchCoaching = createAsyncThunk('coachings/fetchOne', async (id) => {
  const { data } = await api.get(`/coachings/${id}/`);
  return data;
});

export const fetchEcheances = createAsyncThunk('coachings/echeances', async (jours = 60) => {
  const { data } = await api.get('/coachings/echeances/', { params: { jours } });
  return data;
});

export const createCoaching = createAsyncThunk('coachings/create', async (payload, { rejectWithValue }) => {
  try {
    const { data } = await api.post('/coachings/', payload);
    return data;
  } catch (e) {
    const errData = e.response?.data;
    if (typeof errData === 'string' && errData.includes('<!DOCTYPE'))
      return rejectWithValue({ __html__: `Erreur serveur ${e.response?.status || ''}.` });
    return rejectWithValue(errData || { __reseau__: 'Impossible de contacter le serveur.' });
  }
});

export const updateCoaching = createAsyncThunk('coachings/update', async ({ id, payload }, { rejectWithValue }) => {
  try {
    const { data } = await api.patch(`/coachings/${id}/`, payload);
    return data;
  } catch (e) {
    return rejectWithValue(e.response?.data);
  }
});


const coachingsSlice = createSlice({
  name: 'coachings',
  initialState: { liste: [], echeances: [], coaching: null, loading: false, loadingOne: false, errorOne: null, error: null },
  reducers: {
    clearCoaching: (s) => { s.coaching = null; s.errorOne = null; },
  },
  extraReducers: (b) => {
    b
      .addCase(fetchCoachings.pending,   (s) => { s.loading = true; })
      .addCase(fetchCoachings.fulfilled, (s, { payload }) => {
        s.loading = false;
        s.liste = payload.results || payload;
      })
      .addCase(fetchCoachings.rejected,  (s) => { s.loading = false; })

      .addCase(fetchCoaching.pending,    (s) => { s.loadingOne = true; s.coaching = null; s.errorOne = null; })
      .addCase(fetchCoaching.fulfilled,  (s, { payload }) => { s.loadingOne = false; s.coaching = payload; })
      .addCase(fetchCoaching.rejected,   (s, { error }) => { s.loadingOne = false; s.errorOne = error.message || 'Erreur'; })

      .addCase(fetchEcheances.fulfilled, (s, { payload }) => { s.echeances = payload.echeances || []; })

      .addCase(createCoaching.fulfilled, (s, { payload }) => { s.liste.unshift(payload); })

      .addCase(updateCoaching.fulfilled, (s, { payload }) => {
        s.coaching = payload;
        const idx = s.liste.findIndex(c => c.id === payload.id);
        if (idx !== -1) s.liste[idx] = payload;
      });
  },
});

export const { clearCoaching } = coachingsSlice.actions;
export default coachingsSlice.reducer;
